import request from '@/common/js/request.js'

export function getBroadCastList () {
  const url = '/liveVideo/liveVideoNotice'
  return request({
    url: url,
    method: 'get',
  })
}

export function getChatRoomMembers (obj) {
  return request({
    url: '/im/getChatroomMember',
    method: 'post',
    data: obj
  })
}

// 加入聊天室
export function fetchJoinImUser (obj) {
  return request({
    url: '/im/joinImUser',
    method: 'post',
    data: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/broadcast.js